import React from "react";
import cx from "clsx"
import styles from "./scss/Anteheader.module.scss";
import classesResponsive from "../Shared/scss/Responsive.module.scss";
import PhoneIcon from "../Shared/Icons/PhoneIcon";
import MailIcon from "../Shared/Icons/MailIcon";
import FacebookIcon from "../Shared/Icons/FacebookIcon";
import InstagramIcon from "../Shared/Icons/InstagramIcon";
import LocationIcon from "../Shared/Icons/LocationIcon";

const AnteHeader = () => {
  return (
    <div className={cx(styles.anteheaderContainer, classesResponsive.paddingLeftRight)}>
      <div className={styles.anteContent}>
        <div className={styles.contacts}>
          <div className={styles.field}>
            <PhoneIcon color="white" />
            <span>+40 123 456 789</span>
          </div>
          <div className={cx(styles.field, styles.email)}>
            <MailIcon color="white" />
            <span>contact@artdent.ro</span>
          </div>
          <div className={styles.field}>
            <LocationIcon color="white" />
            <span>Nufarului 9, Valea Lupului</span>
          </div>
        </div>
        <div className={styles.socials}>
          <FacebookIcon />
          <InstagramIcon />
        </div>
      </div>
    </div>
  );
};

export default AnteHeader;
